import Vue from 'vue'
import VModal from 'vue-js-modal'
import VuejsDialog from 'vuejs-dialog'

Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: false } })

Vue.use(VuejsDialog, {
  html: true,
  loader: false,
  okText: 'Procedi',
  cancelText: 'Cancella',
  animation: 'fade'
})



// WEBPACK FOOTER //
// ./src/front/init/components/modal.js